import { UNDISCLOSED_EVENT_VALUE } from '../../support/utils/eo_constants';

export const basicFormatter = (value) => {
  if (value === UNDISCLOSED_EVENT_VALUE) {
    return UNDISCLOSED_EVENT_VALUE;
  }

  return (value || 0).toLocaleString('en-US');
};
